const { contractsValidationsErrorMessages } = require('constants/contractsValidations');
const {
    EURO_SYMBOL,
    INTERVENER_LABEL_HOLDER,
    INTERVENER_LABEL_AUTHORIZED,
    INTERVENER_LABEL_EMPOWERED
} = require('constants/index');

module.exports = {
    title: 'contractsView-depositThirteenMonthsStep2Title',
    order: 2,
    footer_text: '',
    disableNext: 'depositThirteenMonthsLinkedMaturities_nextButtonDisabled',
    position: 'middle',
    components:
        [
            {
                id_component: 'dropdown-accounts',
                label: 'contractsView-depositThirteenMonthsStep2Account',
                options: [],
                type: 'single',
                target: 'cta_seleccionada',
                targetIntervener: 'intervinientes_list',
                intervenersSpecial: true,
                order: 1,
                isIntervenerAvailable: true,
                renderInterveners: 'depositThirteenMonthsLeakRetention_shouldBuild',
                isMaxAmountLabelAvailable: false,
                intervenersHeader: 'contractsView-depositThirteenMonthsIntervenersHeader',
                maxAmountValue: 0,
                required: true,
                errorMessage: contractsValidationsErrorMessages.ERROR_MESSAGE_REQUIRED_DROPDOWN_ACCOUNTS_DEPOSIT_THIRTEEN,
                accountChangeExtraFn: 'refreshDeposit13MonthsLinkedMaturitiesHireInformation', //que?
                intervenersHierarchicalTypeSelection: true,
                intervenerOptions: [
                    INTERVENER_LABEL_HOLDER,
                    INTERVENER_LABEL_AUTHORIZED,
                    INTERVENER_LABEL_EMPOWERED
                ],
                showIntervenerControls: true,
                restoreDefaultIntervenersEnabled: true
            },
            {
                id_component: 'slider',
                label: 'contractsView-depositThirteenMonthsStep2Amount',
                min_value: 0,// is populated by service
                max_value: 0,// is populated by service
                default_value: 0,// is populated by service
                value: null,// is populated by service
                type: 'single',
                format_type: EURO_SYMBOL,
                onChangeFn: 'depositThirteenMonthsLinkedMaturities_onChangeAmount',
                is_money: true,
                title: 'contractsView-amountTitle',
                target: 'monto_traspasar',
                source: 'depositThirteenMonthsLinkedMaturities_loadSliderAmounts',
                buildExtraInfo: 'depositThirteenMonthsLinkedMaturities_buildSliderExtraInfo',
                tooltipNoPadding: true,
                buildCondition: 'depositThirteenMonthsLinkedMaturities_shouldBuild'
            },
            {
                id_component: 'interest-band'
            },
            {
                id_component: 'checkbox',
                id: 'renewDeposit',
                target: 'renewDeposit',
                label: 'contractsView-depositThirteenMonthsStep2Renew',
                type: 'single',
                onChangeFn: 'depositThirteenMonthsLinkedMaturities_onChangeCheckbox',
                buildCondition: 'depositThirteenMonthsLinkedMaturities_shouldBuild'
            },
            {
                id_component: 'validation-modal',
                id: 'validationModal',
                title: 'depositThirteenMonthsLinkedMaturities_FinalModalTitle',
                titleType: 'calculated',
                content: 'depositThirteenMonthsLinkedMaturities_FinalModalChildren',
                allowContinue: true,
                open: 'depositThirteenMonthsLinkedMaturities_showFinalModal',
                showCloseButton: false,
                leaveButtonText: 'contractsView-depositThirteenMonthsBackButtonModal'
            },
            {
                id_component: 'validation-modal',
                id: 'accountModal',
                title: 'contractsView-depositThirteenMonthsStep2InitialModalTitle',
                content: 'depositThirteenMonthsLinkedMaturities_InitialModalChildren',
                allowContinue: false,
                showCloseButton: false,
                leaveButtonText: 'contractsView-depositThirteenMonthsBackButtonModal'
            },
            {
                id_component: 'disclaimer-personal-info',
                messageKey: 'depositThirteenMonthsMsg',
                linkTextKey: 'depositThirteenMonthsLinkText',
                linkUrlKey: 'depositThirteenMonthsLinkUrl'
            }
        ]
};